import { OutlinedInput } from "@mui/material";
import { NewRequestMetadataInputProps } from "../new-request-metadata-input";
import { useTranslation } from "react-i18next";

const NewRequestInputCast = (props: NewRequestMetadataInputProps) => {
  const { t } = useTranslation();
  const { metadata, value, isErrored, onChange } = props;

  return (
    <OutlinedInput
      value={value ? (value.lastname === undefined ? value.name : value.name + " " + value.lastname) : ""}
      error={isErrored}
      onChange={(e) => onChange(e.target.value)}
      placeholder={t("field:placeholder.firstNameLastName")}
    />
  );
};

export default NewRequestInputCast;
